module.exports = __webpack_public_path__ + "static/img/icon_open.8510bac7.png";